
import React, { useCallback, useEffect, useMemo, useState } from 'react';

// import instance from '../../../api/authentication';
import instance from '../../../api/authentication'
import { MaterialReactTable } from 'material-react-table';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';

import InputLabel from '@mui/material/InputLabel';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//example of creating a mui dialog modal for creating new rows
export const SessionCreationPage = ({ open, columns, onClose, onSubmit }) => {

    const[categotyItem,setCategoryItem]=useState([]);
    const[productItem,setProductItem]=useState([]);
    const [opens, setOpen] = React.useState(false);
    const [tableData, setTableData] = useState([]);
    
    const handleClose = () => {
      setOpen(false);
    };
  
    const handleOpen = () => {
      setOpen(true);
    };
  
    // !---======Apicall for Session submit======---!
  const handleonSubmit=(productItem)=>{
    console.log(productItem)
    const postData={
      pageRef:productItem.menuId,
      name:productItem.session,
     
    };
   instance
    .post(`/createPageDetails`,postData)
    .then((Response)=>{
      console.log(Response)
      onClose();
    })
  
  }

  //Api call for category listing
  const getPageList =()=>{
    instance
    .get(`/getPageList`)
    .then((response)=>{
      if(response.data.message == "Success"){
        setTableData(response.data.data)
        //  setCreateModalOpen(false)
        //  setEditModalOpen(false)
      }
    })
  }
  useEffect(()=>{
    getPageList();
  },[])
  
    return (
      <Dialog open={open}>
        <DialogTitle textAlign="center">Create New session </DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => e.preventDefault()}>
            <Stack
              sx={{
                width: '100%',
                minWidth: { xs: '300px', sm: '360px', md: '400px' },
                gap: '1.5rem',
              }}
            >
              <FormControl sx={{ m: 1, minWidth: 140 }}>
          <InputLabel id="demo-controlled-open-select-label">menu</InputLabel>
          <Select
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            open={opens}
            onClose={handleClose}
            onOpen={handleOpen}
            name='menuId'
            label="select the menu"
            onChange={(e) =>
              setProductItem({ ...productItem, [e.target.name]: e.target.value })
            }
          >
           
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {tableData?.map((state)=>{
              return(
                <MenuItem key={state._id} value={state._id}>
              {state.name}
            </MenuItem> 
              )
              
            })}
           
          </Select>
          
        </FormControl>
                <TextField
                  // key={}
                  label='Session'
                  name='session'
                  onChange={(e) =>
                    setProductItem({ ...productItem, [e.target.name]: e.target.value })
                  }
                />
            </Stack>
            </form>
        </DialogContent>
        <DialogActions sx={{ p: '1.25rem' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="secondary" onClick={()=>handleonSubmit(productItem)}  variant="contained">
           Submit
          </Button>
        </DialogActions>
       
      </Dialog>
    );
  };